export default __webpack_public_path__ + "static/media/phoneSVG.14e3487e.svg";